module.exports = __webpack_public_path__ + "static/ExactMetrics-24763fceb7b6c7164d258f92a65e9ba6.svg";